import {
  PatientLabResultControllerApi,
  UploadLabResultAbnormalFlagEnum,
  UploadLabResultDocumentFormatEnum,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  patientId: string;
  labDescription: string;
  documentFormat: UploadLabResultDocumentFormatEnum;
  file: File;
  patientOrderId?: string;
  abnormalFlag?: UploadLabResultAbnormalFlagEnum;
  recordedDate?: string;
  note?: string;
  resultValue?: string;
  xTENANTID?: string;
  fileName?: string;
}

/**
 * @author Rajkumar Rathod
 */
export const useCreateOrderResult = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientLabResultControllerApi(getConfigObject()).uploadLabResult(
      params?.patientId,
      params?.labDescription,
      params?.patientOrderId,
      params?.documentFormat,
      params?.abnormalFlag,
      params?.recordedDate,
      params?.note,
      params?.resultValue,
      params?.fileName,
      params?.xTENANTID,
      params?.file
    )
  );
